<template>
  <el-dialog
    title="打标签"
    :visible.sync="state"
    width="30%"
    destroy-on-close
    :before-close="handleClose"
    @close="dialogClose"
  >
    <div
      style="
        border: 1px solid #ddd;
        border-radius: 10px;
        max-height: 200px;
        overflow-y: auto;
      "
    >
      <el-tag
        style="margin: 10px"
        v-for="(tag, index) in tags"
        :key="index"
        :type="tag.type"
        effect="dark"
        @click="handleChecks(tag, index)"
        :class="{ active: tag.checked }"
      >
        {{ tag.label }}
      </el-tag>
    </div>
    <div class="button-group">
      <el-button class="form-button tz-save-btn" @click="submitFn"
        >保存</el-button
      >
    </div>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    tags: Array
  },
  data() {
    return {
      form: {},
      labelCodeList: []
    }
  },
  methods: {
    //多选
    handleChecks(tag, index) {
      console.log(tag, index)
      this.$emit('check', tag, index)
    },
    getlist() {
      var arr = this.tagOptions
      var newArr = []
      var color = [
        '#5c9eff',
        '#74c650',
        '#909399',
        '#e6a23c',
        '#f56c6c',
        '#9392eb',
        '#e9eb85',
        '#97a2b3',
        '#6980c5',
        '#70dfdf',
        '#3390FF',
        '#9192ab',
        '#7898e1',
        '#efa666',
        '#eddd86',
        '#9987ce',
        '#63b2ee',
        '#76da91'
      ]
      for (var i = 0; i < arr.length; i++) {
        newArr.push(arr[i].invoice)
        // 去重
        newArr = Array.from(new Set(newArr))
      }

      for (var j = 0; j < newArr.length; j++) {
        //生成对应数量的颜色 随机色不好看 如果数据重复量小 可以自己写一组颜色用 够用就行## 标题
        // color.push(this.getColor())
        for (var k = 0; k < arr.length; k++) {
          if (newArr[j] === arr[k].invoice) {
            arr[k].color = color[j]
          }
        }
      }
      console.log(arr, '颜色')

      this.tagOptions = arr
    },

    dialogClose() {
      console.log('关闭')
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn() {
      this.$emit('confirm')
      console.log('更新数据处理')
    }
  }
}
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  .form-button {
    margin: 0 20px;
  }
}
</style>
